import React, { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import DBHandler from '../javascript/index-db/db-handler';

// Wrapper component that defers rendering until React is ready
const PWAUpdateHandler = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // Small delay to ensure React and Vite are fully initialized
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 150);

    return () => clearTimeout(timer);
  }, []);

  if (!isReady) {
    return null;
  }

  return <PWAUpdateHandlerInner />;
};

// Inner component with error boundary protection
class PWAUpdateHandlerInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.error('PWA Update Handler Error:', error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('PWA Update Handler caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return <PWAUpdateHandlerCore />;
  }
}

// Core component with the actual PWA logic
const PWAUpdateHandlerCore = () => {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log('SW Registered: ', r);
    },
    onRegisterError(error) {
      console.log('SW registration error', error);
    },
  });

  const update_process = () => {
    const dbHandler = DBHandler();
    dbHandler.reset_non_critical_table().then(() => {
      console.log('reset_non_critical_table -- DONE');
    }).catch((err) => {
      console.log('reset_non_critical_table -- CATCH');
      window.location.reload();
    }).finally(() => {
      console.log('reset_non_critical_table -- FINALLY');
      window.location.reload();
    });
  };

  useEffect(() => {
    if (offlineReady) {
      const MySwal = withReactContent(Swal);
      MySwal.fire({
        position: 'top-end',
        icon: '',
        title: 'Ready for offline use',
        showConfirmButton: false,
        timer: 1500
      });
    }
  }, [offlineReady]);

  useEffect(() => {
    if (needRefresh) {
      const MySwal = withReactContent(Swal);
      MySwal.fire({
        position: 'top-end',
        icon: '',
        title: 'Update Available',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'On next launch',
      }).then((result) => {
        if (result.isConfirmed) {
          const MySwal = withReactContent(Swal);
          MySwal.fire({
            title: 'Loading Update',
            html: '',
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
            },
            willClose: () => {
              // clearInterval(timerInterval)
            }
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              updateServiceWorker(true);
              update_process();  // TODO: Apply this if we need to reset the database
            }
          });
        } else {
          setNeedRefresh(false);
        }
      });
    }
  }, [needRefresh, updateServiceWorker, setNeedRefresh]);

  return null; // This component doesn't render anything
};

export default PWAUpdateHandler;
